import React, { useEffect, useState } from "react";
import app from "./firebase-config";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    let unsubscribeUser = null;

    const unsubscribeAuth = app.auth().onAuthStateChanged((user) => {
      if (unsubscribeUser) {
        unsubscribeUser();
        unsubscribeUser = null;
      }

      if (!user) {
        localStorage.removeItem("usuario");
        localStorage.removeItem("usuarioToken");
        setCurrentUser(null);
        setUserData(null);
        setAuthReady(true);
        return;
      }

      localStorage.setItem("usuario", user.uid);
      localStorage.setItem("usuarioToken", true);
      setCurrentUser(user);

      unsubscribeUser = app
        .firestore()
        .collection("users")
        .doc(user.uid)
        .onSnapshot((snap) => {
          setUserData(snap.exists ? snap.data() : null);
          setAuthReady(true);
        }, () => {
          setUserData(null);
          setAuthReady(true);
        });

      try {
        app
          .messaging()
          .getToken()
          .then((token) => {
            if (!token) return;

            app
              .firestore()
              .collection("users")
              .doc(user.uid)
              .update({ token: token, connected: true });
          })
          .catch(() => {});
      } catch (error) {}
    });

    return () => {
      if (unsubscribeUser) unsubscribeUser();
      unsubscribeAuth();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, userData, authReady }}>
      {children}
    </AuthContext.Provider>
  );
};
